export const DATE_FORMAT_ISO_DAY = 'yyyy-MM-dd' as const;
